import { render } from "./landingPage.vue?vue&type=template&id=75d25c4e&scoped=true"
import script from "./landingPage.vue?vue&type=script&lang=js"
export * from "./landingPage.vue?vue&type=script&lang=js"

import "./landingPage.vue?vue&type=style&index=0&id=75d25c4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d25c4e"]])

export default __exports__